import { Box } from '@customerio/pluma-components/react';

/** Password step. Placeholder — content lands with the password step PR. */
export function PasswordStep() {
  return <Box data-testid="signup-step-password" />;
}
